import React, { useContext, useState } from 'react';
import { Button, Col, Form, Input, Radio, Row } from 'antd';
import InputRut from '../../../components/form/inputs/InputRut';
import { rutValidator } from '../../../utils/validators';
import tokens from '../../../utils/tokens';
import enrollmentAction from '../../../providers/EnrollmentContextProvider/enrollmentAction';
import './styles.less';
import { EnrollmentFormContext } from '../../../providers/EnrollmentFormContextProvider';
import { EnrollmentContext } from '../../../providers/EnrollmentContextProvider';
import EnrollmentView from '../../../enums/EnrollmentView';
import IdentificationType from '../../../enums/identificationType';
import form from '../../../utils/form';

const DeclaringPersonForm = () => {
  const [selectedRut, setSelectedRut] = useState(false);
  const { enrollmentForm } = useContext(EnrollmentFormContext);
  const { dispatch } = useContext(EnrollmentContext);

  const toggleRutCheck = () => {
    setSelectedRut(true);
    enrollmentForm.setFieldsValue({
      declaringPerson: {
        identification: '',
      },
    });
  };
  const allowLettersAndWS = RegExp(
    '^(s*[a-zA-ZáéíóúAÁÉÍÓÚäëïöüÄËÏÖÜ\u00f1\u00d1]*)+(s*[a-zA-ZáéíóúAÁÉÍÓÚäëïöüÄËÏÖÜ\u00f1\u00d1]*)*[a-zA-ZáéíóúAÁÉÍÓÚäëïöüÄËÏÖÜ\u00f1\u00d1 ]*$'
  );
  const allowNumbers = RegExp('^[0-9]+$');

  const togglePassportCheck = () => {
    setSelectedRut(false);
    enrollmentForm.setFieldsValue({
      declaringPerson: {
        identification: '',
      },
    });
  };

  const handleSubmit = () => {
    dispatch({ type: enrollmentAction.GO_TO_VIEW, payload: EnrollmentView.LegalPersonForm });
  };

  return (
    <Row className="declaringPersonForm">
      <Col span={24}>
        <Form form={enrollmentForm} layout="vertical" onFinish={handleSubmit}>
          <Row justify="center">
            <Col className="declaringPersonForm__title" span={24}>
              Datos de la persona declarante
            </Col>
          </Row>
          <Row gutter={tokens.forms.horizontalGutterInPx}>
            <Col span={24}>
              <Form.Item
                label="Nombres"
                name={['declaringPerson', 'name']}
                rules={[
                  {
                    required: true,
                    message: 'Nombre es requerido',
                  },
                  {
                    pattern: allowLettersAndWS,
                    message: 'ingrese solo letras',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={tokens.forms.horizontalGutterInPx}>
            <Col lg={12} xs={24}>
              <Form.Item
                label="Apellido paterno"
                name={['declaringPerson', 'firstSurname']}
                rules={[
                  {
                    required: true,
                    message: 'Dato requerido',
                  },
                  {
                    pattern: allowLettersAndWS,
                    message: 'ingrese solo letras',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col lg={12} xs={24}>
              <Form.Item
                label="Apellido materno"
                name={['declaringPerson', 'secondSurname']}
                rules={[
                  {
                    pattern: allowLettersAndWS,
                    message: 'ingrese solo letras',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Col span={24}>
            <Form.Item name={['declaringPerson', 'identificationType']}>
              <Radio.Group defaultValue={1}>
                <Radio value={IdentificationType.RUT} onChange={toggleRutCheck}>
                  Rut
                </Radio>
                <Radio value={IdentificationType.PASAPORTE} onChange={togglePassportCheck}>
                  Pasaporte
                </Radio>
                <Radio value={IdentificationType.OTRO} onChange={togglePassportCheck}>
                  Otro
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Row gutter={tokens.forms.horizontalGutterInPx}>
            <Col lg={12} xs={24}>
              <Form.Item
                label="N° de Identificación"
                name={['declaringPerson', 'identification']}
                rules={[
                  {
                    required: true,
                    validator: selectedRut ? rutValidator : undefined,
                    message: 'Rut invalido',
                  },
                ]}
              >
                {selectedRut ? <InputRut /> : <Input type="text" maxLength={12} />}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={tokens.forms.horizontalGutterInPx}>
            <Col lg={12} xs={24}>
              <Form.Item
                label="E-mail"
                name={['declaringPerson', 'email']}
                rules={[
                  {
                    required: true,
                    type: 'email',
                    message: 'Email es requerido',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col lg={12} xs={24}>
              <Form.Item
                label="Reescriba su e-mail"
                name={['declaringPerson', 'emailConf']}
                dependencies={['email']}
                rules={[
                  {
                    required: true,
                    message: 'Email es requerido',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('declaringPerson').email === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Email no es igual al primero digitado'));
                    },
                  }),
                ]}
              >
                <Input autoComplete="off" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={tokens.forms.horizontalGutterInPx}>
            <Col lg={12} xs={24}>
              <Form.Item
                label="Teléfono"
                name={['declaringPerson', 'phone']}
                rules={[
                  {
                    required: true,
                    message: 'Dato requerido',
                  },
                  {
                    pattern: allowNumbers,
                    message: 'Ingrese un número válido',
                  },
                ]}
              >
                <Input maxLength={9} />
              </Form.Item>
            </Col>
            <Col lg={12} xs={24}>
              <Form.Item
                label="Teléfono Fijo (opcional)"
                name={['declaringPerson', 'phoneAlt']}
                normalize={form.normalizers.numeric}
              >
                <Input maxLength={9} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={tokens.forms.horizontalGutterInPx}>
            <Col span={24}>
              <Form.Item
                label="Cargo o Parentesco con el(los) Representante(s)
                Legal(es)"
                name={['declaringPerson', 'positionOrRelationship']}
                rules={[
                  {
                    required: true,
                    message: 'Nombre es requerido',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col lg={12} xs={24}>
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="enrollmentLegalFormContainer__button"
                  type="primary"
                >
                  Continuar
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default DeclaringPersonForm;
